/* eslint-disable */
export const sendFranchisingRequest = options => {
	return new Promise((resolve, reject) => {
		$.ajax({
			url: '/franchising/sendRequest',
			data: options,
			dataType: 'json',
			type: 'POST'
		}).done(response => {
			if (response.result === true) {
				resolve(response);
			} else {
				console.log('Something wrong');
				console.log(response.message);
				reject();
			}
		}).error(e => {
			console.log('Something wrong! AJAX ERROR! ', e);
			reject();
		});
	});
};